import React from 'react';
import { useNavigate } from 'react-router-dom';
import defaultAvatar from '../../assets/profileimage.jpg';
import '../../styles/ContactItem.scss';

const MSG_PREVIEW_LENGTH = 28;

function formatContactTime(timestamp) {
  if (!timestamp) return '';
  const seconds = timestamp.seconds !== undefined ? timestamp.seconds : timestamp;
  if (!seconds) return '';
  const date = new Date(seconds * 1000);
  const now = new Date();
  const diffMin = Math.floor((now - date) / 60000);
  if (diffMin < 1) return 'just now';
  if (diffMin < 60) return `${diffMin}m`;
  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return `${diffH}h`;
  const diffD = Math.floor(diffH / 24);
  if (diffD < 7) return `${diffD}d`;
  return date.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
}

const ContactItem = ({ contactName, contactPhotoURL, urlLocation, unreadCount, contactData, lastMessage, currentUserId, onSelect }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (!contactData) {
      console.error('contactData is missing:', contactName);
      return;
    }
    onSelect?.();
    navigate(urlLocation, { state: { contactData } });
  };

  const previewText = () => {
    if (!lastMessage) return '';
    const isOwn = lastMessage.uid === currentUserId;
    const prefix = isOwn ? 'You: ' : '';
    if (lastMessage.message) {
      const msg = lastMessage.message;
      return prefix + (msg.length > MSG_PREVIEW_LENGTH ? msg.slice(0, MSG_PREVIEW_LENGTH) + '...' : msg);
    }
    if (lastMessage.attachedImageUrl) return prefix + '📷 Photo';
    return '';
  };

  const timeStr = formatContactTime(lastMessage?.timestamp);

  return (
    <div className={`message-item${unreadCount > 0 ? ' message-item--unread' : ''}`} onClick={handleClick}>
      <div className="message-item-image">
        <img src={contactPhotoURL && contactPhotoURL.startsWith('http') ? contactPhotoURL : defaultAvatar} alt="Contact Avatar" onError={(e) => { e.target.onerror = null; e.target.src = defaultAvatar; }} referrerPolicy="no-referrer" />
      </div>
      <div className="message-item-info">
        <div className="message-item-top-row">
          <p className="item-name-bold">{contactName}</p>
          {timeStr && <span className="item-timestamp">{timeStr}</span>}
        </div>
        <div className="message-item-bottom-row">
          <p className="item-preview-text">{previewText()}</p>
          {unreadCount > 0 && (
            <div className="message-item-badge">
              <span>{unreadCount}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactItem;
